import Text from 'components/Text'
import React from 'react'

export default function TextBodySmaller (props) {
  return (
    <Text
      fs='smaller'
      {...props}
    />
  )
}
